import { BrowserView, MobileView } from 'react-device-detect';

import { Button } from '@material-ui/core';
import { PDFData } from '../../../Content';

interface PDFContentProps {
  content: PDFData;
}

export const PDFContent: React.FC<PDFContentProps> = ({ content }) => {
  return (
    <>
      <BrowserView>
        <div style={{ position: 'relative', minHeight: '70vh' }}>
          <iframe
            title="pdf-viewer"
            src={`${content.src}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      </BrowserView>
      <MobileView>
        <div>
          <p>
            To view the PDF please click the button below to open in a new tab.
          </p>
          <Button
            variant="contained"
            color="primary"
            href={content.src}
            target="_blank"
            rel="noreferrer"
          >
            Open PDF
          </Button>
        </div>
      </MobileView>
    </>
  );
};
